import { render, staticRenderFns } from "./ContactResponseView.vue?vue&type=template&id=3b810dc9&"
import script from "./ContactResponseView.vue?vue&type=script&lang=js&"
export * from "./ContactResponseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports